import { Injectable } from '@angular/core';
import { CHAT_DESK_CONFIG } from '@constants/chat-desk-config';

@Injectable({
  providedIn: 'root'
})
export class ChatDeskService {

  initFreshChat() {
    (<any>window).fcWidget.init(
      {
        token: CHAT_DESK_CONFIG.token,
        host: CHAT_DESK_CONFIG.host,
        widgetUuid: CHAT_DESK_CONFIG.widgetUuid
      }
    );
  }

  loadFreshChatScript(document, scriptId, src: string) {
    if (document.getElementById(scriptId)) {
      this.initFreshChat();
    } else {
      var scriptElement = document.createElement("script");
      scriptElement.id = scriptId;
      scriptElement.async = true;
      scriptElement.src = src;
      scriptElement.onload = this.initFreshChat;

      document.head.appendChild(scriptElement);
    }
  }

  logoutFromFreshChat() {
    (<any>window).fcWidget.destroy();
  }
}
